  <app-header-lg 
    [userItems]="userItems"
    [isLogin]="loggedIn"
    [userLogin]="userLogin"
    (modal)="openedModal($event)"
    (logOut)="logOut()"
    class="hidden lg:block"
    [menuItems]="menuItems"/>

  <app-header-mobile 
    (modal)="openedModal($event)"
    [isLogin]="loggedIn"
    (logOut)="logOut()"
    class="block lg:hidden w-full relative z-50"
    [linkPanelMobile]="linkPanelMobile"
    [userNameMobile]="userNameMobile"
    [menuItems]="menuItems"/>

<app-modal
  [header]="true"
  [overflow]="'auto'"
  [width]="modalWidth"
  *ngIf="_modalStatus">

  <div content>
    <app-auth [refralCode]="refralCode" [view]="_modalView" />
  </div>

</app-modal>